<template>
    <!-- Cabeçalho -->
    <header>
        <div class="cardapio-digital-cabecalho-container custom-header">
            <img v-bind:src="caminho" alt="Logo">
        </div>
    </header>
</template>

<script>
import store from '@/store';

export default {
    name: 'HearderLogo',
    computed: {
        caminho() {
            return store.state.dadosJson.configuracao ? store.state.dadosJson.configuracao.logo : '' 
        }
    }
}
</script>

<style scoped>
    .cardapio-digital-cabecalho-container {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 7.1rem;
        min-width: 100vw;
        /* background-color: #23A076; */
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    }

    .cardapio-digital-cabecalho-container img {
        max-width: 100px;
    }
</style>